import { get, post, _delete } from './Tools';

const getByDate = async (fecha, isSupervisor = false, supervisorId = null) => {
    let url = `${process.env.REACT_APP_SERVER}checada_dia/by-date?fecha=${fecha}`;

    url += `&is_supervisor=${isSupervisor}`;
    if (supervisorId) {
        url += `&supervisor_id=${supervisorId}`;
    }

    const response = await get(url);
    return response;
};

const getById = async (id) => {
    const response = await get(`${process.env.REACT_APP_SERVER}checada_dia/${id}`);
    return response;
};

const createOrUpdate = async (data) => {
    const response = await post(`${process.env.REACT_APP_SERVER}checada_dia/create-or-update`, data);
    return response;
}

const deleteById = async (id) => {
    const response = await _delete(`${process.env.REACT_APP_SERVER}checada_dia/${id}`);
    return response;
}

const recalcularPorFecha = async (fecha) => {
    const response = await post(
        `${process.env.REACT_APP_SERVER}checada_dia/recalcular-por-fecha`,
        { fecha }
    );
    return response;
}

export { getByDate, getById, createOrUpdate, deleteById, recalcularPorFecha };